var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "SwitchOn",

    getDefaultProps () {
        return {"data-svgreactloader":"[[null,\"dc\",\"http://purl.org/dc/elements/1.1/\"],[null,\"cc\",\"http://creativecommons.org/ns#\"],[null,\"rdf\",\"http://www.w3.org/1999/02/22-rdf-syntax-ns#\"],[null,\"svg\",\"http://www.w3.org/2000/svg\"],[\"http://www.w3.org/2000/svg\",\"sodipodi\",\"http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd\"],[\"http://www.w3.org/2000/svg\",\"inkscape\",\"http://www.inkscape.org/namespaces/inkscape\"],[\"http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd\",\"docname\",\"switch-on.svg\"],[\"http://www.inkscape.org/namespaces/inkscape\",\"version\",\"1.0 (6e3e5246a0, 2020-05-07)\"]]","xmlns":"http://www.w3.org/2000/svg","id":"svg8","version":"1.1","viewBox":"0 0 33.866666 16.933334","height":"64","width":"128"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <defs id="defs2"/>
  <g id="layer1" data-svgreactloader="[[&quot;http://www.inkscape.org/namespaces/inkscape&quot;,&quot;groupmode&quot;,&quot;layer&quot;],[&quot;http://www.inkscape.org/namespaces/inkscape&quot;,&quot;label&quot;,&quot;Layer 1&quot;]]">
    <path id="rect10-6" data-svgreactloader="[[null,&quot;style&quot;,&quot;color:#000000;overflow:visible;opacity:1;fill:#000000;stroke:none;stroke-width:1;stroke-opacity:0.988846;paint-order:markers fill stroke;stop-color:#000000&quot;]]" d="m 8.466667,1.0583334 c -4.1042167,0 -7.4083334,3.3041167 -7.4083334,7.4083337 0,4.1042159 3.3041167,7.4083329 7.4083334,7.4083329 H 25.4 c 4.104217,0 7.408333,-3.304117 7.408333,-7.4083329 0,-4.104217 -3.304116,-7.4083337 -7.408333,-7.4083337 z M 25.4,3.1750001 A 5.2916665,5.2916665 0 0 1 30.691667,8.4666671 5.2916665,5.2916665 0 0 1 25.4,13.758333 5.2916665,5.2916665 0 0 1 20.108333,8.4666671 5.2916665,5.2916665 0 0 1 25.4,3.1750001 Z m -9.948747,1.950269 a 0.68769276,0.68769276 0 0 1 0.522966,1.126546 l -4.455543,5.3128519 a 0.68527084,0.68527084 0 0 1 -0.494542,0.243399 h -0.03204 A 0.68527084,0.68527084 0 0 1 10.507886,11.607043 L 7.8620528,8.9612101 a 0.68527084,0.68527084 0 0 1 0.9684163,-0.968417 l 2.1166669,2.1166659 3.968749,-4.7361429 a 0.68769276,0.68769276 0 0 1 0.535368,-0.248047 z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/switch-on.svg